/**
 * DTMLineChart — Time-series / trend line chart
 * Use for: value trends over time, pick value calendar, historical performance
 */
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid, ReferenceLine } from "recharts";
import { TOKENS, ChartFigure } from "./tokens";

export function DTMLineChart({
  data,           // [{ x, ...series values }]
  title,
  subtitle,
  source,
  series,         // [{ key, name, color, dashed? }]
  xKey = "x",
  height = 260,
  formatter = (v) => v,
  xFormatter,
  annotations = [],  // [{ x, label, color }] — vertical reference lines
  domain,
  className = "",
}) {
  return (
    <ChartFigure title={title} subtitle={subtitle} source={source} className={className}>
      <ResponsiveContainer width="100%" height={height}>
        <LineChart data={data} margin={{ left: 0, right: 10, top: 8, bottom: 0 }}>
          <CartesianGrid stroke={TOKENS.grid} strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey={xKey}
            tick={{ fontSize: 10, fill: "#a3a3a3", fontFamily: TOKENS.body }}
            tickFormatter={xFormatter}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 10, fill: TOKENS.muted, fontFamily: TOKENS.mono }}
            domain={domain}
            tickFormatter={formatter}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={TOKENS.tooltipStyle}
            formatter={(v) => formatter(v)}
            labelFormatter={xFormatter}
          />
          <Legend
            iconType="line"
            iconSize={12}
            wrapperStyle={{ fontSize: 10, fontFamily: TOKENS.body, color: "#888" }}
          />
          {annotations.map((a, i) => (
            <ReferenceLine
              key={i}
              x={a.x}
              stroke={a.color || TOKENS.muted}
              strokeDasharray="4 3"
              label={{
                value: a.label,
                position: "top",
                fill: a.color || TOKENS.muted,
                fontSize: 9,
                fontFamily: TOKENS.mono,
              }}
            />
          ))}
          {series.map((s) => (
            <Line
              key={s.key}
              type="monotone"
              dataKey={s.key}
              name={s.name}
              stroke={s.color || TOKENS.green}
              strokeWidth={2}
              strokeDasharray={s.dashed ? "6 3" : undefined}
              dot={false}
              activeDot={{ r: 4, fill: s.color || TOKENS.green, stroke: TOKENS.bg, strokeWidth: 2 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </ChartFigure>
  );
}
